import React from 'react'

export const FooterScreen = () => {
  return (
    <div style={{ backgroundColor: '#666666' }}>
      <div style={{ color: '#ffffff', textAlign: 'center' }}>
        <div style={{ paddingTop: '2vh', paddingBottom: '0vh' }}><h5>CENTRO COMUNITARIO <b>LA MOYA</b>
          <a href="https://walink.co/f3a001" target="_blank" style={{ color: '#ffffff', paddingLeft: '1vh', paddingBottom: '2vh', textDecoration: 'none' }}>
            | +593 998752686
          </a>

          <a href="https://www.facebook.com/lamoya.moya.98" target="_blank" style={{ color: '#ffffff', paddingLeft: '2vh', paddingBottom: '2vh', textDecoration: 'none' }}>
            <i className="fab fa-facebook fa-2x"></i>
          </a>
          <a href="https://walink.co/f3a001" target="_blank" style={{ color: '#ffffff', paddingLeft: '2vh', paddingBottom: '2vh', textDecoration: 'none' }}>
            <i className="fab fa-whatsapp fa-2x"  ></i>
          </a>
          <a href="https://www.instagram.com/comuna_lamoya.ofical/" target="_blank" style={{ color: '#ffffff', paddingLeft: '2vh', paddingBottom: '2vh', textDecoration: 'none' }}>
            <i className="fab fa-instagram fa-2x"></i>
          </a>
          </h5>
        </div>
        <div style={{ paddingTop: '0vh', paddingBottom: '2vh' }}>
          <a href="https://walink.co/f3a001" target="_blank" style={{ color: '#ffffff', paddingLeft: '1vh', paddingBottom: '2vh', textDecoration: 'none' }}>
            Desarrollo Web: SOFTCODI
          </a>
        </div>
      </div>
    </div>

  )
}
